<main style="min-height: 33.34vw;">
  <div class="row mt-3">
    <!-- <label class="col-6 rqstClarify">
      <div class="rqstIcon"><img src="../../../assets/images/request-clarification.png"></div>
      <span *ngIf="!isArabic">Request clarification</span>
      <span *ngIf="isArabic">طلب توضيح</span>
    </label> -->
  </div>
  <div class="accordion setup-panel" id="accordionExample" *ngIf="selectedCategoryDetails"
    [ngClass]="isArabic ? 'arabicAlign' : ''">
    <div class="accordion-item" *ngFor="let scList of selectedCategoryDetails.subCategoryList">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button" [ngClass]="(scList.isCompleted) ? 'complete' : ''" type="button"
          data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
          (click)="changeSubcategory(scList.subCategory)">
          <span class="accordion-left" [ngClass]="isArabic ? 'arabicAlign' : ''">
            <span *ngIf="!isArabic || (isArabic && !scList.subCategoryArabic)">{{scList.subCategory}}</span>
            <span *ngIf="isArabic && scList.subCategoryArabic">{{scList.subCategoryArabic}}</span>
          </span>
          <span class="accordion-right" *ngIf="scList.isCompleted">100% Done
            <img src="../../../assets/images/Vector.png" alt="">
          </span>
        </button>
      </h2>
      <app-subcategory *ngIf="selectedSubCategory === scList.subCategory && !scList.isCompleted"
        [category]="selectedCategory" [subcategory]="selectedSubCategory" [isLastSection]="isLastSection"
        [isLastCategory]="isLastCategory" [isLastSubcategory]="isSelectedSubcategoryLast"
        [unansweredQues]="unansweredQues" [returnQues]="returnQues"
        (subcategoryStatusCheck)="checkSubcategoryStatus($event)"
        (resetReturnQues)="handleResetReturnQues()"
        (completedChange)="onChildComplete()"></app-subcategory>
    </div>
  </div>

  <div class="submitQuestionnaireBtn" *ngIf="!isResubmit && !isView">
    <!-- <button type="submit" class="btn btn-primary mb-3" (click)="callSubmitAssessment()"
      [disabled]="!allQuesDone || disabledBtn"> -->
    <button type="submit" class="btn btn-primary mb-3" (click)="callSubmitAssessment()"
      [disabled]="!allQuesCompleted || disabledBtn">
      <span *ngIf="!isArabic">SUBMIT ASSESSMENT</span>
      <span *ngIf="isArabic">إرسال التقييم</span>
    </button>
  </div>
  <div class="submitQuestionnaireBtn" *ngIf="isResubmit && !isView">
    <button type="submit" class="btn btn-primary mb-3" (click)="callSubmitAssessment()" [disabled]="disabledBtn">
      <span *ngIf="!isArabic">RESUBMIT ASSESSMENT</span>
      <span *ngIf="isArabic">إعادة تسليم التقييم</span>
    </button>
  </div>
  <div class="errMsg serverErr mb-3" *ngIf="serverErr">
    <span>{{serverErr}}</span>
  </div>
</main>